const initialState = {
    androidTotalFormsCount: 0,
    webAppTotalFormsCount: 0,
    iosTotalFormsCount: 0,
    androidTotalQuizCount: 0,
    webAppTotalQuizCount: 0,
    iosTotalQuizCount: 0,
    // Cross-platform
    crossPlatformAndroidWebAppForm: 0,
    crossPlatformIosWebAppForm: 0,
    crossPlatformAndroidIosForm: 0,
    crossPlatformAndroidWebAppQuiz: 0,
    crossPlatformIosWebAppQuiz: 0,
    crossPlatformAndroidIosQuiz: 0,
    // Single platform
    singlePlatformAndroidForm: 0,
    singlePlatformWebAppForm: 0,
    singlePlatformIosForm: 0,
    singlePlatformAndroidQuiz: 0,
    singlePlatformWebAppQuiz: 0,
    singlePlatformIosQuiz: 0,
    // Total forms and quizzes
    totalForms: 0,
    totalQuizzes: 0,
    // Response counts
    androidFormResponses: 0,
    webAppFormResponses: 0,
    iosFormResponses: 0,
    androidQuizResponses: 0,
    webAppQuizResponses: 0,
    iosQuizResponses: 0,
};

export const ADMIN_DETAILS_ACTION_TYPE = {
    SET_ANDROID_TOTAL_FORMS_COUNT: 'SET_ANDROID_TOTAL_FORMS_COUNT',
    SET_WEBAPP_TOTAL_FORMS_COUNT: 'SET_WEBAPP_TOTAL_FORMS_COUNT',
    SET_IOS_TOTAL_FORMS_COUNT: 'SET_IOS_TOTAL_FORMS_COUNT',
    SET_ANDROID_TOTAL_QUIZ_COUNT: 'SET_ANDROID_TOTAL_QUIZ_COUNT',
    SET_WEBAPP_TOTAL_QUIZ_COUNT: 'SET_WEBAPP_TOTAL_QUIZ_COUNT',
    SET_IOS_TOTAL_QUIZ_COUNT: 'SET_IOS_TOTAL_QUIZ_COUNT',
    SET_CROSS_PLATFORM_ANDROID_WEBAPP_FORM: 'SET_CROSS_PLATFORM_ANDROID_WEBAPP_FORM',
    SET_CROSS_PLATFORM_IOS_WEBAPP_FORM: 'SET_CROSS_PLATFORM_IOS_WEBAPP_FORM',
    SET_CROSS_PLATFORM_ANDROID_IOS_FORM: 'SET_CROSS_PLATFORM_ANDROID_IOS_FORM',
    SET_CROSS_PLATFORM_ANDROID_WEBAPP_QUIZ: 'SET_CROSS_PLATFORM_ANDROID_WEBAPP_QUIZ',
    SET_CROSS_PLATFORM_IOS_WEBAPP_QUIZ: 'SET_CROSS_PLATFORM_IOS_WEBAPP_QUIZ',
    SET_CROSS_PLATFORM_ANDROID_IOS_QUIZ: 'SET_CROSS_PLATFORM_ANDROID_IOS_QUIZ',
    SET_SINGLE_PLATFORM_ANDROID_FORM_COUNT: 'SET_SINGLE_PLATFORM_ANDROID_FORM_COUNT',
    SET_SINGLE_PLATFORM_WEBAPP_FORM_COUNT: 'SET_SINGLE_PLATFORM_WEBAPP_FORM_COUNT',
    SET_SINGLE_PLATFORM_IOS_FORM_COUNT: 'SET_SINGLE_PLATFORM_IOS_FORM_COUNT',
    SET_SINGLE_PLATFORM_ANDROID_QUIZ_COUNT: 'SET_SINGLE_PLATFORM_ANDROID_QUIZ_COUNT',
    SET_SINGLE_PLATFORM_WEBAPP_QUIZ_COUNT: 'SET_SINGLE_PLATFORM_WEBAPP_QUIZ_COUNT',
    SET_SINGLE_PLATFORM_IOS_QUIZ_COUNT: 'SET_SINGLE_PLATFORM_IOS_QUIZ_COUNT',
    SET_TOTAL_FORM_COUNT: 'SET_TOTAL_FORM_COUNT',
    SET_TOTAL_QUIZ_COUNT:'SET_TOTAL_QUIZ_COUNT'
}

const adminDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case (ADMIN_DETAILS_ACTION_TYPE.SET_ANDROID_TOTAL_FORMS_COUNT):
            return {
                ...state,
                androidTotalFormsCount: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_WEBAPP_TOTAL_FORMS_COUNT):
            return {
                ...state,
                webAppTotalFormsCount: action.payload
            }

        case (ADMIN_DETAILS_ACTION_TYPE.SET_IOS_TOTAL_FORMS_COUNT):
            return {
                ...state,
                iosTotalFormsCount: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_ANDROID_TOTAL_QUIZ_COUNT):
            return {
                ...state,
                androidTotalQuizCount: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_WEBAPP_TOTAL_QUIZ_COUNT):
            return {
                ...state,
                webAppTotalQuizCount: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_IOS_TOTAL_QUIZ_COUNT):
            return {
                ...state,
                iosTotalQuizCount: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_CROSS_PLATFORM_ANDROID_WEBAPP_FORM):
            return {
                ...state,
                crossPlatformAndroidWebAppForm: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_CROSS_PLATFORM_IOS_WEBAPP_FORM):
            return {
                ...state,
                crossPlatformIosWebAppForm: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_CROSS_PLATFORM_ANDROID_IOS_FORM):
            return {
                ...state,
                crossPlatformAndroidIosForm: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_CROSS_PLATFORM_ANDROID_WEBAPP_QUIZ):
            return {
                ...state,
                crossPlatformAndroidWebAppQuiz: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_CROSS_PLATFORM_IOS_WEBAPP_QUIZ):
            return {
                ...state,
                crossPlatformIosWebAppQuiz: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_CROSS_PLATFORM_ANDROID_IOS_QUIZ):
            return {
                ...state,
                crossPlatformAndroidIosFormQuiz: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_SINGLE_PLATFORM_ANDROID_FORM_COUNT):
            return {
                ...state,
                singlePlatformAndroidForm: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_SINGLE_PLATFORM_WEBAPP_FORM_COUNT):
            return {
                ...state,
                singlePlatformWebAppForm: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_SINGLE_PLATFORM_IOS_FORM_COUNT):
            return {
                ...state,
                singlePlatformIosForm: action.payload
            }

        case (ADMIN_DETAILS_ACTION_TYPE.SET_SINGLE_PLATFORM_ANDROID_QUIZ_COUNT):
            return {
                ...state,
                singlePlatformAndroidQuiz: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_SINGLE_PLATFORM_WEBAPP_QUIZ_COUNT):
            return {
                ...state,
                singlePlatformWebAppQuiz: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_SINGLE_PLATFORM_IOS_QUIZ_COUNT):
            return {
                ...state,
                singlePlatformIosQuiz: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_TOTAL_FORM_COUNT):
            return {
                ...state,
                totalForms: action.payload
            }
        case (ADMIN_DETAILS_ACTION_TYPE.SET_TOTAL_QUIZ_COUNT):
            return {
                ...state,
                totalQuizzes: action.payload
            }
        default:
            return state
    }
}

export default adminDetailsReducer